import React, { useState } from 'react';

export const BookingModal = ({ isOpen, onClose, venue, selectedTime, selectedDate }) => {
  const [duration, setDuration] = useState(1);
  const MIN_DURATION = 1;
  const MAX_DURATION = 10;

  if (!isOpen) return null;

  const handleDurationChange = (change) => {
    const newDuration = duration + change;
    if (newDuration >= MIN_DURATION && newDuration <= MAX_DURATION) {
      setDuration(newDuration);
    }
  };

  const basePrice = Number(venue.price);
  const bookingFee = 2;
  const hourlyPrice = basePrice * duration;
  const tax = hourlyPrice * 0.1;
  const total = hourlyPrice + bookingFee + tax;

  // Calculate end time based on duration
  const getEndTime = () => {
    const [time, period] = selectedTime.split(' ');
    const [hours, minutes] = time.split(':');
    let endHours = parseInt(hours) + duration;
    const endPeriod = endHours >= 12 ? 'PM' : period;
    endHours = endHours > 12 ? endHours - 12 : endHours;
    return `${endHours}:${minutes} ${endPeriod}`;
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg w-full max-w-md p-6 relative">
        {/* Close button */}
        <button 
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
        >
          ✕
        </button>

        {/* Modal content */}
        <div className="space-y-6">
          {/* Header */}
          <div className="space-y-2">
            <h2 className="text-2xl font-bold text-gray-900">{venue.name}</h2>
            <p className="text-gray-600">
              {selectedDate?.toLocaleDateString('en-US', { 
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
            </p>
            <p className="text-gray-600">Time: {selectedTime} - {getEndTime()}</p>
          </div>

          {/* Duration selector */}
          <div className="flex items-center justify-center space-x-4 py-4 border-t border-b">
            <button 
              onClick={() => handleDurationChange(-1)}
              className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center hover:bg-gray-300 disabled:opacity-50"
              disabled={duration <= MIN_DURATION}
            >
              -
            </button>
            <div className="text-center">
              <p className="text-2xl font-bold">{duration}</p>
              <p className="text-gray-600">hours</p>
            </div>
            <button 
              onClick={() => handleDurationChange(1)}
              className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center hover:bg-gray-300 disabled:opacity-50"
              disabled={duration >= MAX_DURATION}
            >
              +
            </button>
          </div>

          {/* Pricing breakdown */}
          <div className="space-y-3">
            <div className="flex justify-between">
              <span className="text-gray-600">Venue rental ({duration} hour{duration > 1 ? 's' : ''})</span>
              <span>${hourlyPrice.toFixed(2)}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">Booking fee</span>
              <span>${bookingFee.toFixed(2)}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">Tax</span>
              <span>${tax.toFixed(2)}</span>
            </div>
            <div className="flex justify-between font-bold pt-2 border-t">
              <span>Total</span>
              <span>${total.toFixed(2)}</span>
            </div>
          </div>

          {/* Booking button */}
          <button
            onClick={() => {
              alert(`Booking confirmed for ${duration} hour${duration > 1 ? 's' : ''}!`);
              onClose();
            }}
            className="w-full bg-black text-white py-3 rounded-lg font-semibold hover:bg-gray-800 transition-colors"
          >
            Book Now
          </button>
        </div>
      </div>
    </div>
  );
};